import { useEffect, useState } from "react";
import type { TermLanguage, ValueChangeView } from "../api/types";
import { text } from "../text";
import { useChangeText } from "./PreviewDialog";

const visibleRows = 5;
const lifetimeMs = 12_000;

/** Confirms an applied choice with the values it changed and offers to undo it. */
export function ChangeNotice(props: {
  title: string;
  changes: ValueChangeView[];
  language: TermLanguage;
  onUndo: () => void;
  onClose: () => void;
}) {
  const { onClose } = props;
  const changeText = useChangeText();
  const [paused, setPaused] = useState(false);
  useEffect(() => {
    if (paused) return;
    const timer = window.setTimeout(onClose, lifetimeMs);
    return () => window.clearTimeout(timer);
  }, [onClose, paused, props.title, props.changes]);

  const shown = props.changes.slice(0, visibleRows);
  const hidden = props.changes.length - shown.length;
  return (
    <div
      className="change-notice"
      role="status"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      onFocus={() => setPaused(true)}
      onBlur={() => setPaused(false)}
    >
      <p className="change-notice-title">✓ {props.title}</p>
      {shown.length > 0 && (
        <ul className="change-notice-list">
          {shown.map((change) => (
            <li key={change.key}>
              {text(change.label, props.language)}: {changeText(change, "before")} → {changeText(change, "after")}
            </li>
          ))}
          {hidden > 0 && <li className="muted">und {hidden} weitere</li>}
        </ul>
      )}
      <div className="change-notice-actions">
        <button type="button" className="button secondary" onClick={props.onUndo}>
          Rückgängig
        </button>
        <button type="button" className="icon-button" aria-label="Hinweis schließen" onClick={props.onClose}>
          ×
        </button>
      </div>
    </div>
  );
}
